export default "__VITE_ASSET__d1ce4c01__"